import type { RecordFormItem } from 'types';
import { object } from 'yup';
import { recordItemsValidation } from './recordItemsValidation';

export const useRecordItemsSchema = (items: RecordFormItem[], skipValidation: boolean) => {
  return object().shape(recordItemsValidation(items, skipValidation));
};
